import { gql } from "@apollo/client";

export const seenAtProviderFieldsFragment = gql`
  fragment SeenAtProviderFields on Provider {
    ...ProviderFields
  }
`;
